import React, { createContext, useReducer, useContext, type Dispatch } from 'react';

// Define the SelectOption interface to match the Menu component
interface SelectOption {
  value: string;
  label: string;
}

// Define the FilterRow interface to match the Menu component
export interface FilterRow {
  id: number;
  selectedOption: SelectOption | null;
  valueOption: SelectOption[];
}

// Define the state shape - maps chartId to array of filters
interface ChartFilterState {
  [chartId: string]: FilterRow[];
}

// Define the action types
interface UpdateFiltersAction {
  type: 'UPDATE_FILTERS';
  chartId: string;
  filters: FilterRow[];
}

type ChartFilterAction = UpdateFiltersAction;

const ChartFilterStateContext = createContext<ChartFilterState>({});
const ChartFilterDispatchContext = createContext<Dispatch<ChartFilterAction>>(() => { });

function chartFilterReducer(state: ChartFilterState, action: ChartFilterAction): ChartFilterState {
  switch (action.type) {
    case 'UPDATE_FILTERS':
      return { ...state, [action.chartId]: action.filters };
    default:
      return state;
  }
}

interface ChartFilterProviderProps {
  children: React.ReactNode;
}

export function ChartFilterProvider({ children }: ChartFilterProviderProps) {
  const [state, dispatch] = useReducer(chartFilterReducer, {} as ChartFilterState);
  return (
    <ChartFilterStateContext.Provider value={state}>
      <ChartFilterDispatchContext.Provider value={dispatch}>
        {children}
      </ChartFilterDispatchContext.Provider>
    </ChartFilterStateContext.Provider>
  );
}

export function useChartFilters(): ChartFilterState {
  return useContext(ChartFilterStateContext);
}

export function useChartFilterDispatch(): Dispatch<ChartFilterAction> {
  return useContext(ChartFilterDispatchContext);
}